import { render, staticRenderFns } from "./Beginnings.vue?vue&type=template&id=51eab094&"
import script from "./Beginnings.vue?vue&type=script&lang=js&"
export * from "./Beginnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports